import { useState, useEffect } from "react";

const Stepper = (props: {
  steps: {
    stepNo: number;
    name: string;
    highlighted?: boolean;
    selected?: boolean;
    completed?: boolean;
  }[];
  currentStep: number;
  action: any;
}) => {
  const { steps, currentStep, action } = props;
  const [newStep, setNewStep] = useState<any[]>([]);

  const updateStep = (
    stepNumber: number,
    steps: {
      stepNo: number;
      name?: string;
      highlighted?: boolean;
      selected?: boolean;
      completed?: boolean;
    }[]
  ) => {
    const newSteps = [...steps];
    let count = 0;
    while (count < newSteps.length) {
      if (count === stepNumber) {
        newSteps[count] = {
          ...newSteps[count],
          highlighted: true,
          selected: true,
          completed: true,
        };
        count++;
      } else if (count < stepNumber) {
        newSteps[count] = {
          ...newSteps[count],
          highlighted: false,
          selected: true,
          completed: true,
        };
        count++;
      } else {
        newSteps[count] = {
          ...newSteps[count],
          highlighted: false,
          selected: false,
          completed: false,
        };
        count++;
      }
    }
    return newSteps;
  };

  useEffect(() => {
    const stepsState = steps.map((step, index) =>
      Object.assign(
        {},
        {
          stepNo: step.stepNo,
          name: step.name,
          completed: false,
          highlighted: index === 0 ? true : false,
          selected: index === 0 ? true : false,
        }
      )
    );

    const current = updateStep(currentStep - 1, stepsState);
    setNewStep(current);
  }, [steps, currentStep]);

  const stepsDisplay = newStep.map((step: any, index: number) => {
    return (
      <div
        key={index}
        className={
          index !== 0 ? "flex w-full items-center" : "flex items-center"
        }
      >
        <div
          className={`flex-auto border-t-[4px] border-white transition duration-500 ease-in-out ${
            step.completed ? "opacity-100" : "opacity-10"
          } `}
        />
        <div
          onClick={() => action(step.stepNo)}
          className="relative flex flex-col items-center hover:cursor-pointer"
        >
          <div
            className={`flex h-8 w-8 items-center justify-center rounded-full border-2 transition duration-500 ease-in-out md:h-10 md:w-10 ${
              step.selected
                ? "border-white bg-gradient-to-br from-brand-400 to-brand-600 text-white"
                : "border-[var(--color-300)] bg-white text-gray-500"
            }`}
          >
            <span className="text-sm md:text-base">{step.stepNo}</span>
          </div>
          <p
            className={`absolute top-0 mt-10 w-24 text-center text-xs font-medium text-white md:mt-12 md:w-40 md:text-sm ${
              step.completed ? "opacity-100" : "opacity-30"
            }`}
          >
            {step.name}
          </p>
        </div>
      </div>
    );
  });

  return (
    <div className="mx-2 flex items-center justify-between p-2 md:mx-4 md:p-4">
      {stepsDisplay}
    </div>
  );
};
export default Stepper;
